var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewArrivalsIcon = function SvgNewArrivalsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#new-arrivals-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 0c.39 0 .742.242.879.61l2.32 6.195 6.196 2.32a.938.938 0 0 1-.004 1.754l-6.196 2.32-2.32 6.196a.938.938 0 0 1-1.754-.004l-2.316-6.196L.609 10.88a.938.938 0 0 1 0-1.758l6.196-2.32L9.125.605A.93.93 0 0 1 10 0m0 3.613L8.41 7.86a.95.95 0 0 1-.55.551L3.612 10l4.246 1.59a.95.95 0 0 1 .551.55L10 16.388l1.59-4.246a.95.95 0 0 1 .55-.551L16.388 10 12.14 8.41a.95.95 0 0 1-.551-.55z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "new-arrivals-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgNewArrivalsIcon;